(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  return schemata(
    { address:
      { type: String
      , validators: { all: [ required ] }
      }
    , latitude:
      { type: Number
      , validators: { all: [ required ] }
      }
    , longitude:
      { type: Number
      , validators: { all: [ required ] }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/tour/location-schema.js","/components/service/tour")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS90b3VyL2xvY2F0aW9uLXNjaGVtYS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbInZhciBzY2hlbWF0YSA9IHJlcXVpcmUoJ3NjaGVtYXRhJylcbmNvbnN0IHJlcXVpcmVkID0gcmVxdWlyZSgnQGNsb2NrbGltaXRlZC92YWxpZGl0eS1yZXF1aXJlZCcpXG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gKCkge1xuXG4gIHJldHVybiBzY2hlbWF0YShcbiAgICB7IGFkZHJlc3M6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgLCB2YWxpZGF0b3JzOiB7IGFsbDogWyByZXF1aXJlZCBdIH1cbiAgICAgIH1cbiAgICAsIGxhdGl0dWRlOlxuICAgICAgeyB0eXBlOiBOdW1iZXJcbiAgICAgICwgdmFsaWRhdG9yczogeyBhbGw6IFsgcmVxdWlyZWQgXSB9XG4gICAgICB9XG4gICAgLCBsb25naXR1ZGU6XG4gICAgICB7IHR5cGU6IE51bWJlclxuICAgICAgLCB2YWxpZGF0b3JzOiB7IGFsbDogWyByZXF1aXJlZCBdIH1cbiAgICAgIH1cbiAgICB9XG4gIClcbn1cbiJdfQ==